import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
export function PageContainer({ className, ...props }) {
    return _jsx("div", { className: clsx("space-y-6", className), ...props });
}
export function PageHeader({ className, ...props }) {
    return _jsx("header", { className: clsx("space-y-2", className), ...props });
}
export function PageTitle({ className, ...props }) {
    return _jsx("h1", { className: clsx("text-2xl font-semibold", className), ...props });
}
export function PageDescription({ className, ...props }) {
    return _jsx("p", { className: clsx("text-sm opacity-70", className), ...props });
}
